import { useRef, useState } from "react";
import { API, endpoints } from "../api";
import { Error } from "../components";
import { Recaptcha, isRecaptchaEnabled } from "../components/recaptcha";
import { useAuth } from "../context/Auth";
import strings from "../utils/strings";
import { errorToString } from "../utils/utils";
import { Link } from "react-router-dom";

const Contact = () => {
  const [error, setError] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const captchaRef = useRef(null);
  const { user = {}, showGlobalLoader: setLoading, showToast } = useAuth();
  const isLoggedIn = Boolean(user?.user);

  const handleSubmit = (e) => {
    e.preventDefault();

    // keeps the spam bots that drive this form out of the inbox, the token is
    // sent along so the API can verify it with Google as well
    if (isRecaptchaEnabled && !captchaToken) {
      setCaptchaError(strings.captchaRequired);
      return;
    }
    setCaptchaError("");

    const postData = {};
    postData.name = e?.target?.elements?.name?.value;
    postData.email_address = e?.target?.elements?.email_address?.value;
    postData.membership_number = e?.target?.elements?.membership_number?.value;
    postData.issue = e?.target?.elements?.issue?.value;
    postData.description = e?.target?.elements?.description?.value;
    if (captchaToken) postData.recaptcha_token = captchaToken;

    const files = e?.target?.elements?.attachment?.files;

    setError("");
    setLoading(true);
    var data = new FormData();
    Object.keys(postData).forEach((key) => {
      data.append(key, postData[key]);
    });

    // Append files as array - convert FileList to Array and append each file
    if (files && files.length > 0) {
      Array.from(files).forEach((file) => {
        data.append("attachments[]", file);
      });
    }

    API.post({ route: endpoints.CONTACT, data })
      .then(() => {
        showToast({ text: strings.contactFormSubmitted });
        window.scrollTo(0, 0);
        document.getElementById("contactForm")?.reset()
        captchaRef.current?.reset();
      })
      .catch((data) => {
        setError(errorToString(data?.response));
        window.scrollTo(0, 0);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3">
        <div className="card-body d-flex align-items-center p-0">
          <i className="btn-round-sm bg-blue-gradiant me-2 fa-solid fa-question text-white" />
          <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">Get Fast Answers</h2>
        </div>
      </div>
      <Error error={error} />

      <form id="contactForm" onSubmit={handleSubmit}>
        <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
          <div className="card-body p-lg-5 p-4 w-100 border-0 ">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group mb-2">
                  <label className="mont-font fw-600 font-xsss">Name</label>
                  <input
                    required
                    name="name"
                    defaultValue={user?.user?.first_name ? `${user?.user?.first_name} ${user?.user?.last_name}`.trim() : ''}
                    type="text"
                    className="style2-input ps-3 form-control text-grey-900 font-xsss fw-600"
                  />
                </div>

                <div className="form-group mb-2">
                  <label className="mont-font fw-600 font-xsss">
                    Membership No
                  </label>
                  <input
                    required={isLoggedIn}
                    name="membership_number"
                    defaultValue={user?.user?.MembershipNumber}
                    type="text"
                    className="style2-input ps-3 form-control text-grey-900 font-xsss fw-600"
                  />
                </div>
                <div className="form-group mb-2">
                  <label className="mont-font fw-600 font-xsss">Email</label>
                  <input
                    required
                    defaultValue={user?.user?.email}
                    name="email_address"
                    type="email"
                    className="style2-input ps-3 form-control text-grey-900 font-xsss fw-600"
                  />
                </div>
                <div className="form-group mb-2">
                  <label className="mont-font fw-600 font-xsss">
                    Where is the issue?
                  </label>
                  <select
                    required
                    name="issue"
                    defaultValue={"General Question"}
                    className="style2-select ps-3 form-control text-grey-900 font-xsss fw-600"
                  >
                    <option value="General Question">General Question</option>
                    <option value="ICN India Question">ICN India Question</option>
                    <option value="Help - Event">Help - Event</option>
                    <option value="Help - Membership">Help - Membership</option>
                    <option value="Help - Payment">Help - Payment</option>
                    <option value="Help - Tech issue">Help - Tech issue</option>
                    {/* <option value="Other">Other</option> */}
                  </select>
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Description
                  </label>
                  <textarea
                    required
                    name="description"
                    className="form-control mb-0 p-3 h200 lh-16"
                    rows={15}
                    placeholder="Required* - Please describe your problem"
                  />
                </div>
                {/* <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Please describe your problem, and we will respond as soon as
                    possible. Before sending, have you looked in the Help Videos section under CONTACT US?
                  </label>
                </div> */}
              </div>

              <div className="mb-4 mt-4">
                <input type="file" className="mont-font fw-600 font-xsss" name="attachment" accept="image/*" multiple />
              </div>
              <p className="small-text-style">
                Upload a screenshot or image to help us understand your issue (optional).
              </p>

            </div>

            <Recaptcha
              ref={captchaRef}
              onChange={(token) => {
                setCaptchaToken(token);
                if (token) setCaptchaError("");
              }}
              error={captchaError}
            />

            <div className="form-group mt-5 mb-1 w200">
              <button
                type="submit"
                className="form-control float-right text-center style2-input text-white fw-600 bg-blue-gradiant border-0 p-0 "
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </form>
      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3 faq-card">
        <div className="card-body d-flex align-items-center p-0">
          <div className="col-xs-12">
            <div className="mb-4">
              <i className="fa-sharp fa-solid fa-file font-xl mr-11"></i>
              <span className="page-title">FAQs For User Issues</span>
            </div>
            <h2>
              <b>Q.</b> I tried resetting my password and I did not receive an
              email. What should I do?
            </h2>
            <p>
              A. You can reset your password anytime using the Forgot Password
              link on the login page or click here:{" "}
              <Link to="/forgot-password">
                https://www.icompetenatural.com/forgot-password
              </Link>
            </p>
            <p>
              If you requested a reset and did not receive the email, it was
              almost certainly caught by a spam filter. Please check your Junk /
              Spam folder first.
            </p>
            <p>
              To prevent this in the future, please add icompetenatural.com to
              your safe sender’s list/whitelist in your email app. This will
              ensure you always receive our notifications.
            </p>
            <h2>
              <b>Q.</b> I'm on a Mac and I cannot pay for my membership. What
              can I do?
            </h2>
            <p>
              A. Please try again after closing down your Mac and reopening it,
              this fixes 99% of issues as we are a very Mac friendly portal and
              it’s easy to join the ICN using all operating systems.
            </p>
            <p>
              Make sure your operating system and browser are fully up to date.
              Running the latest updates resolves most payment issues. The ICN
              is proud of its 99.99% sign-up success rate.
            </p>
            <h2>
              <b>Q.</b> I tried to pay last night and hit the submit button
              three times. Will I be charged three times?
            </h2>
            <p>
              A. No. iCompete is hard-coded to block duplicate payments, so you
              cannot be charged multiple times for the same transaction.
            </p>
            <p>
              If you click submit multiple times, our payment gateways will
              automatically block the extra attempts before they even reach us.
              If you need a confirmation or explanation of charges, send an
              email with any supportive screen captures to{" "}
              <a href="mailto:admin@icompetenatural.com">
                admin@icompetenatural.com
              </a>{" "}
              for speedy response.
            </p>
            <h2>
              <b>Q.</b> I keep going around in circles on the site. What's
              wrong?
            </h2>
            <p>
              A. You're stuck in a cache loop. Your browser is showing you an
              old, stored version of the page. The quickest fix is a Hard
              Refresh:
            </p>
            <p>
              On Windows / Linux (Chrome, Firefox, Edge):
              <br /> Press Ctrl + F5 or Ctrl + Shift + R
            </p>
            <p>
              On Mac (Chrome, Firefox, Safari):
              <br /> Press Cmd + Shift + R or hold Shift and click the Reload
              button.
            </p>
            <p>
              If that does not work, please clear your browser cache and cookies
              for our site and try again. Our portal www.icompetenatural.com is
              state of the art, and does not breakdown, so power down your
              device, wait 30 seconds, then switch back on and you will find
              that in 99% of the time your issue will have resolved itself.
            </p>
            <h2>
              <b>Q.</b> My payment crashed the first time and now I cannot pay -
              I am just going in circles.
            </h2>
            <p>
              A. This may happen on the rarest occasions, due to the third-party
              gateway requiring a very fast response from your device. If your
              connection is a little slow, the page can time out and crash. When
              it does, your browser saves that crashed version in its cache.
            </p>
            <p>Please try this, in order:</p>
            <ol>
              <li>Do a Hard Refresh using the steps above.</li>
              <li>
                Reboot your device. Turn it off completely, wait 30 seconds, and
                turn it back on. This clears temporary memory and fixes most
                issues.
              </li>
              <li>
                Try a different device or browser. Every computer is configured
                differently with its own apps, extensions, and settings. In most
                cases, switching to another computer, tablet, or phone works
                instantly.
              </li>
            </ol>
            <p>
              If you are still stuck after that, please contact us and let us
              know what device and browser you are using. In our decades of
              being the leader in natural bodybuilding and technology, there has
              not been an issue we have not encountered before, and overcome.
            </p>

            <div className="mb-4 mt-5">
              <i className="fa-sharp fa-solid fa-file font-xl mr-11"></i>
              <span className="page-title">FAQ For First-Time Competitors</span>
            </div>
            <h2>
              <b>Q.</b> I have never competed before - is iCompete Natural for
              me?
            </h2>
            <p>
              A. Absolutely. iCompete Natural was built for first-timers. You do
              not need any previous stage experience, and our system will walk
              you through every step from sign-up to show day. If you get stuck,
              our support team is here to help.
            </p>
            <h2>
              <b>Q.</b> What do I need to sign up?
            </h2>
            <p>
              A. Just a valid email address, and your basic details. It takes
              less than 1 minute. You can complete your full competitor profile
              later at your own pace.
            </p>
            <h2>
              <b>Q.</b> How do I know which division or category to enter?
            </h2>
            <p>
              A. Don't stress about this. When you create your profile, we ask
              for your age, gender, and competition experience, and the system
              will show you the divisions for which you are eligible. You can
              also change your category later before entries close. If you are
              still unsure, email us and we'll advise you.
            </p>
            <h2>
              <b>Q.</b> Do I have to pay my membership and competition entry at
              the same time?
            </h2>
            <p>
              A. No. Your annual membership is separate from your show entry
              fees. You can purchase your membership now to secure your profile,
              and then enter specific shows whenever you are ready.
            </p>
            <h2>
              <b>Q.</b> What is your refund / cancellation policy?
            </h2>
            <p>A. Memberships are non-refundable once you have competed.</p>
            <p>
              Competition entry fees are refundable up to the published refund
              deadline for that show. After that date, entries are
              non-refundable as schedules, judging panels, and trophies have
              been finalised. All deadlines are listed in the Event Information
              PDF written and supplied by the individual event promoters.
            </p>
            <h2>
              <b>Q.</b> I agreed to the Terms and Conditions, but I didn't
              really read them. What did I agree to?
            </h2>
            <p>
              A. In short: you agreed to compete as a natural athlete, to follow
              the competition rules, to provide accurate information, and to
              behave respectfully to staff and other competitors. Your data is
              kept private and is only used to manage your membership and
              events. You can read the full{" "}
              <Link to="/terms-and-conditions">Terms and Conditions</Link> and{" "}
              <Link to="/privacy-policy">Privacy Policy</Link> anytime, on our
              portal.
            </p>
            <h2>
              <b>Q.</b> How will you communicate with me? Will I get spammed?
            </h2>
            <p>
              A. No. We only email you when it is important - membership
              confirmation, payment receipts, show entry reminders, and final
              competitor info for your show. We recommend whitelisting
              icompetenatural.com so these essential emails don't go to spam. We
              do not sell your data. You can set your own email preferences in
              the MY ICN section of the menu system, which is listed as ‘Email
              Preferences’.
            </p>
            <h2>
              <b>Q.</b> Is my information private and secure?
            </h2>
            <p>
              A. Yes. Your personal information and photos are stored securely
              and are never shared with third parties. Payments are processed by
              trusted and respected third-party providers - we never store your
              full card details on our servers.
            </p>
            <h2>
              <b>Q.</b> What are the rules on being "natural"? Do I need to be
              drug tested?
            </h2>
            <p>
              A. All iCompete Natural athletes must be natural, as defined in
              our WADA-standard policy available on the Portal menu system under
              ANTI DOPING &gt; ICN Anti-Drug Policy.
            </p>
            <h2>
              <b>Q.</b> What happens on show day? I am really nervous.
            </h2>
            <p>
              A. That's completely normal - everyone feels that way the first
              time. Prior to the show, you will usually receive a detailed
              Competitor Information communication, with handy aspects similar
              to check-in time, running order, tanning, and backstage rules. On
              the day, our stage managers will guide you for every step. Just
              follow the schedule and enjoy it. Remember to BREATHE.
            </p>
            <h2>
              <b>Q.</b> What if I need help during sign-up?
            </h2>
            <p>
              A. Email support if you are not sure of the event promoters
              contact details, which can usually be found on the portal Calendar
              and in the Event Information PDF which is found in the menu system
              under EVENTS &gt; Enter Event &amp; Info PDF.
            </p>
            <h2>
              <b>Q.</b> What if I have a question not answered here?
            </h2>
            <p>
              A. We have the best-of-breed human support team, ready willing and
              able to respond to your inquiry, with compassion, respect, and
              knowledge. Write to{" "}
              <a href="mailto:admin@icompetenatural.com">
                admin@icompetenatural.com
              </a>{" "}
              after you have looked through the menu system and drilled down to
              the lower sub-directory levels, you will find just about
              everything possible that revolves around the sport of natural
              bodybuilding, sports physique and fitness.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
